import { wordOfMouth } from '@/mocks/movies';

export default function WordOfMouth() {
  return (
    <section id="word" className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-medium text-secondary-700 tracking-widest">WORD OF MOUTH</span>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              口碑电影：观众怎么说
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              评分之外，真实的观看感受往往更有参考价值。这里摘录了几部长期被提起的作品及其口碑标签，帮你判断是否对味。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {wordOfMouth.map((item) => (
              <article
                key={item.id}
                className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 font-heading font-bold text-lg shrink-0">
                    {item.title.slice(0, 1)}
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 truncate">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500">
                      {item.year} · 整理评分 {item.douban.toFixed(1)}
                    </p>
                  </div>
                  <i className="ri-double-quotes-r text-2xl text-secondary-300 ml-auto shrink-0" aria-hidden="true"></i>
                </div>

                <p className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">{item.quote}</p>

                <div className="mt-4 flex flex-wrap gap-1.5">
                  {item.tags.map((t) => (
                    <span
                      key={t}
                      className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] md:text-xs"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}